var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          "left-side-class": "col-xl-4",
          page: _vm.page,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-2 justify-content-end"
        },
        scopedSlots: _vm._u([
          {
            key: "customActions",
            fn: function() {
              return [
                _vm.canUploadDocuments
                  ? _c("action-button", {
                      attrs: {
                        i: "fas fa-file-plus",
                        text: "Cargar Documentos",
                        variant: "success"
                      },
                      on: { click: _vm.onShowUploadFiles }
                    })
                  : _vm._e(),
                _c("input", {
                  ref: "uploadFiles",
                  staticStyle: { display: "none" },
                  attrs: { accept: ".pdf", multiple: "", type: "file" },
                  on: { change: _vm.onUploadFiles }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "filter-manager",
        {
          ref: "certificationLoadFilterRef",
          attrs: {
            filters: _vm.filterManagerConfig.basic,
            "search-text": null
          },
          on: {
            academicYear: _vm.onChangeAcademicYear,
            center: _vm.onChangeCenter,
            month: _vm.onChangeMonth,
            service: _vm.onChangeService,
            specialist: _vm.onChangeSpecialist,
            specialistsOrCompanies: _vm.onChangeSpecialistsOrCompanies,
            status: _vm.onChangeStatus,
            therapyDocumentType: _vm.onChangeTherapyDocumentType
          },
          model: {
            value: _vm.filter,
            callback: function($$v) {
              _vm.filter = $$v
            },
            expression: "filter"
          }
        },
        [
          _c("div", { staticClass: "main-box col-md-10" }, [
            _c("i", { staticClass: "fas fa-bell-exclamation" }),
            _c("span", [
              _vm._v(
                " Recordatorio: Es importante actualizar la factura antes de comenzar el proceso de carga de certificaciones. "
              )
            ])
          ]),
          _c(
            "div",
            { staticClass: "col-md mt-3 text-right" },
            [
              _c("action-button", {
                attrs: { text: "Buscar", variant: "success px-4" },
                on: { click: _vm.onSearchHandler }
              })
            ],
            1
          )
        ]
      ),
      _c("custom-separator", {
        staticClass: "pt-3 mb-3",
        attrs: { text: "Resultado de Certificaciones" }
      }),
      _vm.results.length > 0
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [
                _c("div", { staticClass: "info-container mt-3" }, [
                  _c("div", { staticClass: "d-flex align-items-center col" }, [
                    _vm._m(0),
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c("div", { staticClass: "color-gray-6 font-14" }, [
                        _vm._v("Especialista")
                      ]),
                      _c(
                        "div",
                        { staticClass: "color-black font-16 font-weight-bold" },
                        [_vm._v(" " + _vm._s(_vm.specialistInfo.name) + " ")]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _vm._m(1),
                    _c("div", { staticClass: "color-black font-25 ml-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.specialistInfo.totalStudent) + " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _vm._m(2),
                    _c("div", { staticClass: "color-black font-25 ml-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.specialistInfo.succeedTotal) + " "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _vm._m(3),
                    _c("div", { staticClass: "color-black font-25 ml-4" }, [
                      _vm._v(
                        " " + _vm._s(_vm.specialistInfo.pendingTotal) + " "
                      )
                    ])
                  ]),
                  _vm.specialistInfo.errorDocumentCount > 0
                    ? _c("div", { staticClass: "col" }, [
                        _vm._m(4),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              { staticClass: "color-black font-25 ml-4 mr-4" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.specialistInfo.errorDocumentCount
                                    ) +
                                    " "
                                )
                              ]
                            ),
                            _vm.specialistInfo.errorDocumentCount > 0
                              ? _c(
                                  "u",
                                  {
                                    staticClass: "color-green cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.showError = true
                                      }
                                    }
                                  },
                                  [_vm._v(" Ver Detalles ")]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _c("div", { staticClass: "border-bottom my-3" }),
            _vm.showError && _vm.specialistInfo.errorDocumentCount > 0
              ? _c(
                  "div",
                  [
                    _c("file-error", {
                      attrs: { errors: _vm.specialistInfo.errorMessages },
                      on: {
                        close: function($event) {
                          _vm.showError = false
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "mt-3" },
              [
                _c(
                  "validation-observer",
                  {
                    ref: "editDocumentForm",
                    attrs: { novalidate: "", tag: "form" }
                  },
                  _vm._l(_vm.resultsData, function(item, index) {
                    return _c(
                      "div",
                      { key: "massive-certification" + index },
                      [
                        _c(
                          "custom-callout",
                          {
                            staticClass: "mb-3 custom-callout",
                            attrs: {
                              "border-color": _vm.getColor(
                                _vm.documentStatusId(item)
                              ),
                              "show-edition": item.isOpen
                            },
                            scopedSlots: _vm._u(
                              [
                                item.isOpen
                                  ? {
                                      key: "edition",
                                      fn: function() {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "info-panel" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "info-panel-main-title"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "dot color-orange",
                                                              staticStyle: {
                                                                height: "25px"
                                                              }
                                                            },
                                                            [
                                                              _c("em", {
                                                                staticClass:
                                                                  "title-icon fa fa-file-edit font-14"
                                                              })
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "ml-n1"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Editar Documento"
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "info-panel-container"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row px-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6"
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Tipo de Documento: "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-drop-down",
                                                                          {
                                                                            attrs: {
                                                                              clearable: false,
                                                                              "custom-error-msg":
                                                                                "Favor de seleccionar el tipo el documento.",
                                                                              error:
                                                                                errors[0],
                                                                              fieldkey:
                                                                                "id",
                                                                              fieldname:
                                                                                "name",
                                                                              options:
                                                                                _vm.therapyDocumentTypes,
                                                                              placeholder:
                                                                                "Seleccione"
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.documentType,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "documentType",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.documentType"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "color-secondary-6"
                                                            },
                                                            [_vm._v("Archivo")]
                                                          ),
                                                          _c(
                                                            "validation-provider",
                                                            {
                                                              attrs: {
                                                                rules:
                                                                  "required"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function({
                                                                      errors
                                                                    }) {
                                                                      return [
                                                                        _c(
                                                                          "custom-file-input",
                                                                          {
                                                                            ref:
                                                                              "attachedDocument",
                                                                            refInFor: true,
                                                                            attrs: {
                                                                              accept:
                                                                                ".pdf",
                                                                              "custom-error-msg":
                                                                                "Favor de anejar un documento.",
                                                                              "display-style":
                                                                                "normal",
                                                                              error:
                                                                                errors[0],
                                                                              "label-position":
                                                                                "left",
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                item.selectedDocument,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  item,
                                                                                  "selectedDocument",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "item.selectedDocument"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-4 text-right mt-3"
                                                        },
                                                        [
                                                          _c(
                                                            "action-button",
                                                            {
                                                              attrs: {
                                                                i:
                                                                  "fas fa-times-circle",
                                                                variant:
                                                                  "outline-danger btn-cancel danger m-2"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.onCancelEdit(
                                                                    item,
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Cancelar "
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "action-button",
                                                            {
                                                              attrs: {
                                                                variant:
                                                                  "success m-2 pl-4 pr-4"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.handleSave(
                                                                    item,
                                                                    index
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Guardar "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  : null
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-2 col-sm-12 icon-container border-right"
                                },
                                [
                                  _c("custom-balloon", {
                                    staticClass:
                                      "mt-2 p-2 font-weight-normal font-16",
                                    attrs: {
                                      "background-color": _vm.getColor(
                                        _vm.documentStatusId(item)
                                      ),
                                      text: _vm.getStatusName(
                                        _vm.documentStatusId(item)
                                      )
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 col-sm-12 col-spacing student-spacing"
                                },
                                [
                                  _c("div", { staticClass: "legend" }, [
                                    _vm._v("SIE:")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal text-black"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.studentSieId) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-3 col-sm-12 col-spacing service-place-spacing"
                                },
                                [
                                  _c("div", { staticClass: "legend" }, [
                                    _vm._v("Estudiante:")
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal text-black"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.studentName) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-2 col-sm-12 col-spacing"
                                },
                                [
                                  item.documentName
                                    ? _c("div", { staticClass: "legend" }, [
                                        _vm._v("Documento:")
                                      ])
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal text-black"
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(item.documentName) + " "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-2 col-sm-12 col-spacing d-flex justify-content-end"
                                },
                                [
                                  _c("action-button", {
                                    staticClass: "ml-0",
                                    attrs: {
                                      disabled: _vm.disabledActionButton(
                                        _vm.documentStatusId(item)
                                      ),
                                      i: "fas fa-file-download",
                                      variant: _vm.getDownloadActionColor(item)
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.onDownloadDocument(item)
                                      }
                                    }
                                  }),
                                  _vm.hideActionButton(item.billingStatusId)
                                    ? _c("action-button", {
                                        staticClass: "ml-2",
                                        attrs: {
                                          disabled: _vm.disabledActionButton(
                                            _vm.documentStatusId(item)
                                          ),
                                          i: "fas fa-file-edit",
                                          variant: _vm.getEditActionColor(item)
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.onToggleEdit(item, index)
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ],
              1
            )
          ])
        : _c(
            "div",
            {
              staticClass:
                "col-12 p-4 text-center align-items-center no-info mt-4"
            },
            [_vm._m(5)]
          )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dot color-orange" }, [
      _c("em", { staticClass: "title-icon fa fa-user-circle" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("em", { staticClass: "fa fa-user-friends color-gray-6 mr-2" }),
      _c("div", { staticClass: "color-gray-6 font-14" }, [
        _vm._v("Total Estudiantes:")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("em", { staticClass: "fa fa-check-circle color-primary-1 mr-2" }),
      _c("div", { staticClass: "color-gray-6 font-14" }, [
        _vm._v("Documentos Cargados:")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("em", { staticClass: "fa fa-clock color-yellow-star mr-2" }),
      _c("div", { staticClass: "color-gray-6 font-14" }, [
        _vm._v("Documentos Pendientes:")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("em", { staticClass: "fa fa-times-circle color-primary-4 mr-2" }),
      _c("div", { staticClass: "color-gray-6 font-14" }, [
        _vm._v("Documentos Con Error:")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-12 col-lg-1 align-self-center" }, [
        _c("i", { staticClass: "far fa-folder-open icon no-info-icon pl-2" })
      ]),
      _c("div", { staticClass: "col-12 col-lg-3 ml-lg-n4 align-self-center" }, [
        _c("span", { staticClass: "no-info-text" }, [
          _vm._v("No hay información disponible.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }